export default __webpack_public_path__ + "static/media/d.5a47f09f.png";